export default {
  common: {
    name: '名前',
    date: '日付',
    dateOfBirth: '生年月日',
    facilityName: '施設名',
    schoolYear: '{year}年度',
    placeholderPreschool: '仮ノ保育園',
  },
  months: {
    apr: '4月',
    may: '5月',
    jun: '6月',
    jul: '7月',
    aug: '8月',
    sept: '9月',
    oct: '10月',
    nov: '11月',
    dec: '12月',
    jan: '1月',
    feb: '2月',
    mar: '3月',
  },
  growthRecord: {
    title: '成長記録',
    height: '身長',
    weight: '体重',
    kaupIndex: 'カウプ指数',
    median: '中央値: {value}{unit}',
    chartTitle: '{year}年度の成長の記録',
    percentileRange: 'パーセンタイル値 3% ~ 97%の範囲',
    chartMonth: '月',
    chartPercentile3: 'パーセンタイル値 3%',
    chartPercentile97: 'パーセンタイル値 97%',
    monthLabel: '{month}月',
  },
  childDevelopment: {
    domain: '領域',
    item: '発達項目',
    previousYear: '前年度',
    schoolYear: '{year}年度',
    rangeLabel: '{startYear}年4月 - {endYear}年3月',
    rangeLabelWithMonth: '{startYear}年4月 - {endYear}年{endMonth}月',
  },
  childDevelopmentAnalytics: {
    title: '発達分析表',
    exportDate: '出力日:',
    analysisPeriod: '分析対象期間:',
    unitMonths: '(単位: ヶ月)',
  },
  workSchedule: {
    dailyTitle: '日次スタッフ予定',
    monthlyTitle: '月次スタッフ予定',
    staffName: '氏名',
    plannedRequiredQualified: '予定: 必要配置有資格者数',
    plannedAssignedQualified: '予定: 配置有資格者数',
    actualRequiredQualified: '実績: 必要配置有資格者数',
    actualAssignedQualified: '実績：配置有資格者数',
    surplusPlanned: '過不足 - 予定',
    surplusActual: '過不足 - 実績',
    dateFull: '{year}年{month}月{day}日',
    dateYearMonth: '{year}年{month}月',
  },
  guidancePlan: {
    schoolYearSuffix: '年度',
  },
};
